import { isNonNullNumber, isNonNullObject, isNonNullString } from './type-guards';

const STATUS_UNAVAILABLE_FOR_LEGAL_REASONS = 451;
const USER_AGREEMENT_NOT_SIGNED_STATUS = 'User agreement not signed';

export default function userAgreementNotAcceptedError(response: unknown) {
  const status =
    isNonNullObject(response) && 'status' in response && isNonNullNumber(response.status)
      ? response.status
      : undefined;

  if (status === STATUS_UNAVAILABLE_FOR_LEGAL_REASONS) {
    const message =
      isNonNullObject(response) &&
      'data' in response &&
      isNonNullObject(response.data) &&
      'message' in response.data &&
      isNonNullString(response.data.message)
        ? response.data.message
        : undefined;

    return message === USER_AGREEMENT_NOT_SIGNED_STATUS;
  }
}
